import * as React from 'react'
import { useEffect } from 'react'
import { Redirect, RouteComponentProps } from 'react-router'
import { Link, Route, Switch } from 'react-router-dom'
import ProviderProductList from '../../containers/products/ProviderProductList'
import ProviderProductActivateModal from '../../containers/products/ProviderProductActivateModal'
import ProviderProductDeactivatedListPane from '../../containers/products/ProviderProductDeactivatedListPane'
import ProviderProductDeactivateModal from '../../containers/products/ProviderProductDeactivateModal'
import ProviderProductDeleteModal from '../../containers/products/ProviderProductDeleteModal'
import ProviderProductSearch from '../../containers/products/ProviderProductSearch'
import ProductDetailPanePage from './details/ProductPanePage'
import EntitiesTopPanel, { EntitiesTopPanelItem } from '../ui/EntitiesTopPanel'
import EntityBottomPanelBtn from '../ui/entity/EntityBottomPanelBtn'
import ProviderProductCreatePage from './ProviderProductCreatePage'
import ErrorBoundary from '../ErrorBoundary'
import { IProviderProductFilters } from 'src/types/provider-product'
import HorizontalSelectorItem from '../HorizontalSelectorItem'
import HorizontalSelector from '../HorizontalSelector'
import UIMessages from 'src/utils/ui-messages'
import history from 'src/history'
import { Button } from '@mobiscroll/react-latest'

const ProviderListTopPane = (props: RouteComponentProps<any>) => {
  const active = !/\/deactivated-products/.test(location.pathname)

  const ROUTES = {
    CREATE_PRODUCT: '/products/create'
  } as const

  const createProduct = () => {
    history.push(ROUTES.CREATE_PRODUCT)
  }

  return (
    <EntitiesTopPanel>
      <div className='flex justify-between items-center'>
        <div>
          <HorizontalSelector>
            <HorizontalSelectorItem isSelected={active}>
              <Link to={`${props.match.path}`}>
                <div>{UIMessages.product.PRODUCTS}</div>
              </Link>
            </HorizontalSelectorItem>
            <HorizontalSelectorItem isSelected={!active}>
              <Link to={`${props.match.path}/deactivated-products`}>
                <div>{UIMessages.product.DEACTIVATED_PRODUCTS}</div>
              </Link>
            </HorizontalSelectorItem>
          </HorizontalSelector>
        </div>
        <div className='flex items-center'>
          <ProviderProductSearch />
          <Button className='mobiscroll-green-btn' onClick={createProduct}>
            <span className='font-white'>+ {UIMessages.common.createNewProduct}</span>
          </Button>
        </div>
      </div>
    </EntitiesTopPanel>
  )
}
//Declaration of URL's
const getLink = (): string => {
  let link = ''
  if (process.env.REACT_APP_GATEWAY_URL) {
    link = process.env.REACT_APP_GATEWAY_URL
    if (process.env.REACT_APP_GATEWAY_URL.includes('dev')) {
      const lnk = process.env.REACT_APP_GATEWAY_URL.split(':')
      link = lnk[1]
    } else if (process.env.REACT_APP_GATEWAY_URL.includes('radar')) {
      const lnk1 = process.env.REACT_APP_GATEWAY_URL.split(':')
      link = lnk1[1]
    }
  }
  return link
}
//Declaration of URL's
const ProviderActiveListPane = (props: RouteComponentProps<any>) => {
  return (
    <React.Fragment>
      <ProviderProductList type='active' />
      {/* Footer */}
      <div
        className='footer-copyright border-box text-left py-3 font-black h6 bold '
        style={{
          marginBottom: '5rem',
          marginTop: '2rem',
          marginLeft: '1rem'
        }}
      >
        &copy; Copyright {new Date().getFullYear()}{' '}
        <a href={`${getLink()}`}>
          <u>GOIN'</u>
        </a>{' '}
        All rights reserved.
      </div>
      {/* Footer */}
    </React.Fragment>
  )
}

const ProviderListPane = (props: RouteComponentProps<any>) => {
  const { match } = props
  return (
    <div className='pt2'>
      <Route component={ProviderListTopPane} />
      <Switch>
        <Route exact={true} path={`${match.path}`} component={ProviderActiveListPane} />
        <Route path={`${match.path}/deactivated-products`} component={ProviderProductDeactivatedListPane} />
      </Switch>
    </div>
  )
}

const ListRedirect = (props: RouteComponentProps<any>) => <Redirect to={`${props.match.path}/list`} />

interface IProviderPaneProps extends RouteComponentProps<any> {
  showDeleteProductModal: boolean
  showDeactivateProductModal: boolean
  showActivateProductModal: boolean
  OrgId: string
  fetchServiceLevels: () => void
  updateProductFilters: (params: IProviderProductFilters) => Promise<any>
}

const ProviderPane = (props: IProviderPaneProps) => {
  const { match } = props

  useEffect(() => {
    const filterPayload: IProviderProductFilters = {}
    filterPayload.organizationId = props.OrgId
    props.updateProductFilters(filterPayload)
    props.fetchServiceLevels()
  }, [])

  return (
    <ErrorBoundary>
      <React.Fragment>
        <Switch>
          <Route exact={true} path={`${match.path}`} component={ListRedirect} />
          <Route path={`${match.path}/list`} component={ProviderListPane} />
          <Route path={`${match.path}/create`} component={ProviderProductCreatePage} />
          <Route path={`${match.path}/:productId`} component={ProductDetailPanePage} />
        </Switch>

        {props.showDeactivateProductModal && <ProviderProductDeactivateModal />}
        {props.showDeleteProductModal && <ProviderProductDeleteModal />}
        {props.showActivateProductModal && <ProviderProductActivateModal />}
      </React.Fragment>
    </ErrorBoundary>
  )
}

export default ProviderPane



// WEBPACK FOOTER //
// ./src/components/products/ProviderProductPane.tsx